@if (!isAuthenticated) {
<div class="w-100">
  <form #frm="ngForm" (submit)="frm.form.valid && onSubmit(frm)">
    <div class="row">
      <div class="col-md-7 col-lg-4 mb-3 mx-auto">
        <div class="card shadow-sm p-3">
          <div class="mb-3 row">
            <label class="col-form-label col-md-12"
              >Enter Password<span class="text-danger">*</span></label
            >
            <div class="col-md-12">
              <input
                type="password"
                name="password"
                class="form-control"
                ngModel
                #password="ngModel"
                required
              />
              @if(frm.submitted && password.invalid) {
              @if(password.hasError('required')) {
              <span class="m-0 text-danger">Password is required.</span>
              } }
            </div>
          </div>
          <div class="mb-2 mx-auto">
            <div>
              <button class="btn btn-primary-sa">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
} @else {
<div class="w-100">
  <h1 class="head1">Alerts</h1>
</div>
<div class="row">
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm p-3" id="div1">
      <p class="head1 fw-400 text-center">Total Alerts</p>
      <div class="counts my-6 pb-4">{{ alertSummary.total_alerts_sum }}</div>
    </div>
  </div>
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm p-3" id="div2">
      <p class="head1 fw-400 text-center">Alert Report</p>
      <p class="text-center">
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [labels]="chartOptions.labels"
          [title]="chartOptions.title"
          [responsive]="chartOptions.responsive"
          [plotOptions]="chartOptions.plotOptions"
          [colors]="chartOptions.colors"
          [legend]="chartOptions.legend"
          [dataLabels]="chartOptions.dataLabels"
          [noData]="chartOptions.noData"
        ></apx-chart>
      </p>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="card px-3 py-4">
      <div class="filter-wrap">
        <div class="filter-item">
          <label for="inputPassword6" class="col-form-label"
            >Filter By Groups</label
          >
          <select
            name="group"
            [(ngModel)]="filter.group"
            class="form-select"
            (change)="onGroupSelectionChange($event)"
          >
            <option value="">All</option>
            @for (group of groups; track group) {
            <option value="{{ group.id }}">{{ group.name }}</option>
            }
          </select>
        </div>
        <div class="filter-item">
          <label for="inputPassword6" class="col-form-label">Search By</label>
          <input
            type="text"
            name="consumer_id"
            [(ngModel)]="filter.consumer_id"
            placeholder="Dev EUI/Consumer ID"
            class="form-control w-150p me-2 mb-2"
            (keyup.enter)="searchByFilter()"
          />
          <button
            class="btn btn-primary-sa btn-sm mb-2 float-start me-2"
            (click)="searchByFilter()"
          >
            Search
          </button>
          <button
            class="btn btn-primary-sa btn-sm mb-2"
            (click)="clearFilter()"
          >
            Clear
          </button>
        </div>
        <div class="filter-item float-xl-end">
          <button
            class="btn btn-primary-sa btn-sm mb-2 ms-2"
            (click)="exportAlertedDevices()"
          >
            Export
          </button>
        </div>
      </div>
      <div class="filter-wrap">
        <div class="float-end">
          @if(!filter.consumer_id) { @if(selectedIds.length) {
          <button class="btn btn-primary-sa btn-sm" (click)="excludeDevices()">
            Delete Selected
          </button>
          } @if(alertedDevices.length) {
          <button class="btn btn-sm btn-link" (click)="excluddeAllDecices()">
            Delete All
          </button>
          } }
        </div>
      </div>
      <div class="table-scroll">
        <table width="100%" class="table table-striped">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Consumer ID</th>
              <th>Consumer Name</th>
              <th>Device EUI</th>
              <th>Last Alert Time</th>
              <th class="text-center">Total Alerts</th>
              @if(!filter.consumer_id) {
              <th></th>
              }
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let device of alertedDevices
                  | paginate
                    : {
                        itemsPerPage: filter.limit,
                        currentPage: filter.page,
                        totalItems: totalRecords
                      };
                index as i
              "
              (click)="
                exportDeviceAlerts(
                  device.id.toString(),
                  device.dev_eui.toString()
                )
              "
              style="cursor: pointer"
            >
              <td>{{ (filter.page - 1) * filter.limit + i + 1 }}</td>
              <td>{{ device.consumer_id }}</td>
              <td>{{ device.consumer_name }}</td>
              <td>{{ device.dev_eui }}</td>
              <td>
                {{
                  device.last_alert_received_on | date : "dd-MM-yyyy HH:mm:ss"
                }}
              </td>
              <td class="text-center">{{ device.total_alerts }}</td>
              @if(!filter.consumer_id) {
              <td>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckIndeterminate"
                    (click)="
                      $event.stopPropagation(); onDeviceIdSelected(device.id)
                    "
                  />
                </div>
              </td>
              }
            </tr>
          </tbody>
        </table>
      </div>
      <nav aria-label="Page navigation" class="pagenav-sa">
        <pagination-controls
          (pageChange)="pageChangeEvent($event)"
        ></pagination-controls>
      </nav>
    </div>
  </div>
</div>
}
